/**
 * 站外来源：首屏快照（document.referrer + 落地 URL 查询参数）。
 * 须在 main.js 中最先 import，保证先于路由与其它逻辑执行。
 */

const EMPTY_SNAPSHOT = Object.freeze({
  landing_referrer: '',
  utm: Object.freeze({
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_term: '',
    utm_content: '',
  }),
  channel_param: '',
})

function parseQueryFromLocation() {
  try {
    const merged = new URLSearchParams()
    const search = typeof window !== 'undefined' && window.location.search ? window.location.search : ''
    if (search.length > 1) {
      new URLSearchParams(search.slice(1)).forEach((v, k) => merged.set(k, v))
    }
    const hash = typeof window !== 'undefined' && window.location.hash ? window.location.hash : ''
    const qi = hash.indexOf('?')
    if (qi !== -1) {
      new URLSearchParams(hash.slice(qi + 1)).forEach((v, k) => merged.set(k, v))
    }
    return merged
  } catch (e) {
    console.log('landing-traffic parseQueryFromLocation', e)
    return new URLSearchParams()
  }
}

function buildSnapshot() {
  const referrer = typeof document !== 'undefined' && document.referrer ? document.referrer : ''
  const params = parseQueryFromLocation()
  const utm = {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
    utm_term: params.get('utm_term') || '',
    utm_content: params.get('utm_content') || '',
  }
  const channelParam = params.get('channel') || ''
  return {
    landing_referrer: referrer,
    utm,
    channel_param: channelParam,
  }
}

function safeBuildSnapshot() {
  try {
    return buildSnapshot()
  } catch (e) {
    console.log('landing-traffic safeBuildSnapshot', e)
    return {
      landing_referrer: EMPTY_SNAPSHOT.landing_referrer,
      utm: { ...EMPTY_SNAPSHOT.utm },
      channel_param: EMPTY_SNAPSHOT.channel_param,
    }
  }
}

const snapshot = safeBuildSnapshot()

export function getLandingReferrerSnapshot() {
  try {
    return snapshot.landing_referrer || ''
  } catch (e) {
    console.log('getLandingReferrerSnapshot', e)
    return ''
  }
}

/** 优先级：UTM > channel 参数 > document.referrer 快照 > direct */
export function resolveLandingExternalSource() {
  try {
    const { utm, channel_param, landing_referrer } = snapshot
    const hasUtm = utm.utm_source || utm.utm_medium || utm.utm_campaign || utm.utm_term || utm.utm_content
    if (hasUtm) {
      const parts = []
      if (utm.utm_source) parts.push(`utm_source=${utm.utm_source}`)
      if (utm.utm_medium) parts.push(`utm_medium=${utm.utm_medium}`)
      if (utm.utm_campaign) parts.push(`utm_campaign=${utm.utm_campaign}`)
      if (utm.utm_term) parts.push(`utm_term=${utm.utm_term}`)
      if (utm.utm_content) parts.push(`utm_content=${utm.utm_content}`)
      return `utm:${parts.join('&')}`
    }
    if (channel_param) {
      return `channel:${channel_param}`
    }
    if (landing_referrer) {
      return landing_referrer
    }
    return 'direct'
  } catch (e) {
    console.log('resolveLandingExternalSource', e)
    return 'direct'
  }
}

/** 数数 super 属性：会话内站外归因一致 */
export function getLandingTrafficSuperProps() {
  try {
    return {
      landing_referrer: snapshot.landing_referrer || '',
      landing_external_source: resolveLandingExternalSource(),
    }
  } catch (e) {
    console.log('getLandingTrafficSuperProps', e)
    return {
      landing_referrer: '',
      landing_external_source: 'direct',
    }
  }
}
